
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"8","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M15 7h6m-6 10.5h6M7 2.5A4 4 0 1010.969 7M6 6l.93.93a.1.1 0 00.14 0L11 3m0 14.5a4 4 0 11-8 0 4 4 0 018 0z","stroke":"#FDFDFD","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    